// extracted by mini-css-extract-plugin
export default {"festivalWrap":"recommendFestival_festivalWrap__g0azm","title":"recommendFestival_title__1QSgs"};